<template>
  <div class="page-main">
    <page-title />
    <page-card style="margin-bottom:32px" v-loading="loading">
      <div slot="body">
        <el-form :model="form" ref="form" label-width="150px">
          <el-form-item prop="id" label="Proposal ID:" :rules="[
            { required: true, message: 'Proposal ID cannot be empty', trigger: 'blur' },
            { type: 'number', message: 'Proposal ID must be a number' }
          ]">
            <el-input v-model.number="form.id" style="width:320px"
              placeholder="Please enter an unexecuted proposal ID"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button :loading="btnLoading1" type="primary" @click="check(1)">Agree</el-button>
            <el-button :loading="btnLoading2" type="primary" @click="check(2)">Execute</el-button>
          </el-form-item>
        </el-form>

      </div>
    </page-card>
    <ErrorMsg ref="ErrorMsg"></ErrorMsg>
  </div>
</template>

<script>
import { getAbi } from '@/api/file';

export default {
  data() {
    return {
      loading: false,
      btnLoading1: false,
      btnLoading2: false,
      contract: null,
      contractAddress: null,
      form: {
        id: '',
      },

    };
  },
  mounted() {
    getAbi('AirDrop').then(result => {
      this.contract = result.contract;
      this.contractAddress = result.address;
    })
  },
  methods: {
    check(val) {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (val === 1) {
            this.handleAgree()
          } else {
            this.handleExecute()
          }
        } else {
          return false;
        }
      });
    },
    handleAgree() {
      this.btnLoading1 = true
      const tx_builder = this.contract.methods["signTransaction"](this.form.id);
      const encoded_tx = tx_builder.encodeABI();
      let json = {
        gas: this.$store.getters.gas,
        from: this.$store.getters.metaMaskObj.account,
        to: this.contractAddress,
        value: 0,
        data: encoded_tx,
      };
      web3.eth
        .sendTransaction(json)
        .then((res) => {
          this.$message.success("operation success");
          this.btnLoading1 = false;
        })
        .catch((error) => {
          console.error(error);
          if (error.code === 4001) {
            this.$message.error(error.message)
          } else {
            this.$refs.ErrorMsg.show(error.receipt.blockNumber)
          }
          this.btnLoading1 = false;
        });

    },
    handleExecute() {
      this.btnLoading2 = true
      const tx_builder = this.contract.methods["executeProposal"](this.form.id);
      const encoded_tx = tx_builder.encodeABI();
      let json = {
        gas: this.$store.getters.gas,
        from: this.$store.getters.metaMaskObj.account,
        to: this.contractAddress,
        value: 0,
        data: encoded_tx,
      };
      web3.eth
        .sendTransaction(json)
        .then((res) => {
          console.log(res)
          this.$message.success("The proposal has been successfully executed！");
          this.btnLoading2 = false;
        })
        .catch((error) => {
          console.log(error)
          if (error.code === 4001) {
            this.$message.error(error.message)
          } else {
            this.$refs.ErrorMsg.show(error.receipt.blockNumber)
          }
          this.btnLoading2 = false;
        });
    },

  },
};
</script>
<style scoped lang="scss">
.msgDio {

  /deep/ .el-dialog__header {
    border-bottom: 0;
  }

  div {
    text-align: center;
    line-height: 30px;
  }
}
</style>
